import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { Information } from "@/components/Information/Information";

export type SameCompanyStopOptionProps = {
	isChecked: boolean;
	onChange: (value: boolean) => void;
};

/**
 * The campaign's `pausePeopleFromTheSameCompany` setting, shared by the create and edit campaign
 * modals so what it says is written once (`list.campaignBuilder.sameCompanyStop*`).
 *
 * The stop is permanent: since PREC-3895 a reply ends the outreach to the lead's colleagues at the
 * same company, on the same list and campaign, and nothing resumes it
 * (`apps/api/src/schedule/same-company-stop.service.ts`). Both modals kept saying "Pause … Resumes
 * automatically once that conversation is closed" for weeks after that change (PREC-4241), so
 * when that service changes what it does, this wording changes with it. The stored key keeps its
 * old name; users never see it.
 */
export const SameCompanyStopOption: FunctionComponent<SameCompanyStopOptionProps> = ({
	isChecked,
	onChange,
}) => {
	const { t } = useTranslation("translation", { keyPrefix: "list.campaignBuilder" });

	return (
		<Checkbox isChecked={isChecked} onChange={() => onChange(!isChecked)}>
			<div className="flex flex-row gap-1 items-center">
				{t("sameCompanyStopLabel")}
				<Information information={t("sameCompanyStopDescription")} />
			</div>
		</Checkbox>
	);
};
